import React, { ReactNode } from 'react';

import { VerticalDotsIcon } from 'assets/icons';
import { IconWrapper } from 'common/components';

interface IProps {
  onToggle: () => void;
  menuToggleIcon?: ReactNode;
}

export const MenuToggle = ({ onToggle, menuToggleIcon }: IProps) => {
  return (
    <>
      <IconWrapper onClick={onToggle}>{menuToggleIcon ?? <VerticalDotsIcon />}</IconWrapper>
    </>
  );
};
